import shortid from "shortid";

export function calculateRowTotalPrice(
  unitPrice: number,
  quantity: number,
  conversionRatio?: number
): number {
  let count: number;
  if (conversionRatio) {
    count = quantity * conversionRatio;
  } else {
    count = quantity;
  }
  let totalPrice = count * unitPrice;
  return totalPrice;
}

export function calculateTableTotalPrice(rows?: { totalPrice?: number }[]): number {
  let totalPrice = 0;
  if (rows === undefined) return totalPrice;
  rows.forEach((item) => {
    if (item.totalPrice === undefined) return;
    totalPrice += item.totalPrice;
  });
  return totalPrice;
}

export function calculateFinalPrice(
  tablePrice: number,
  quantity: number,
  costs: { amount: number }[],
  wages: { amount: number }[]
): number {
  const totalCost = costs.reduce((prev, cur) => prev + cur.amount, 0);
  const totalWage = wages.reduce((prev, cur) => prev + cur.amount, 0);
  const finalPrice = (tablePrice + totalCost + totalWage) * quantity;
  return finalPrice;
}

export function getInitialRows(): MaterialOrderRow[] {
  return [
    { quantity: 0, unitPrice: 0, ind: shortid.generate(), totalPrice: 0 },
    { quantity: 0, unitPrice: 0, ind: shortid.generate(), totalPrice: 0 },
    { quantity: 0, unitPrice: 0, ind: shortid.generate(), totalPrice: 0 },
    { quantity: 0, unitPrice: 0, ind: shortid.generate(), totalPrice: 0 },
  ];
}
